import axios from "axios";

// إعداد axios مع تجاهل مشاكل CORS
const apiClient = axios.create({
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// إضافة interceptor للتعامل مع الأخطاء
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("🔍 API Error Details:", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url
    });
    return Promise.reject(error);
  }
);

const BASE_URL = process.env.REACT_APP_API_URL?.replace('/api/', '') || " https://api.vipwellness-suite.de";

console.log("🌐 API Base URL:", BASE_URL);

// الحصول على جميع الأوقات غير المتاحة
export const getUnavailableTimeSlotsApi = async () => {
  try {
    console.log("  API ENHANCED: Getting unavailable time slots");
    const url = `${BASE_URL}/api/unavailable-time-slots`;
    console.log("📡 API ENHANCED: Request URL:", url);
    
    const response = await apiClient.get(url);
    console.log("✅ API ENHANCED: Got unavailable time slots:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API ENHANCED: Failed to get unavailable time slots:", error);
    
    // في حالة فشل الطلب، إرجاع بيانات افتراضية بدلاً من رمي خطأ
    console.log("🔄 API ENHANCED: Returning fallback data to prevent UI crash");
    return {
      success: true,
      unavailableTimeSlots: [],
      source: 'fallback_due_to_error'
    };
  }
};

// الحصول على الأوقات غير المتاحة لتاريخ معين
export const getUnavailableTimeSlotsForDateApi = async (date) => {
  try {
    console.log("  API: Getting unavailable time slots for date:", date);
    const response = await axios.get(`${BASE_URL}/api/unavailable-time-slots/${date}`);
    console.log("✅ API: Got unavailable time slots for date:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API: Failed to get unavailable time slots for date:", error);
    throw error;
  }
};

// إضافة فترة زمنية غير متاحة
export const addUnavailableTimeSlotApi = async (date, startTime, endTime) => {
  try {
    console.log("➕ API: Adding unavailable time slot:", { date, startTime, endTime });
    const response = await axios.post(`${BASE_URL}/api/unavailable-time-slots/add`, {
      date,
      startTime,
      endTime
    });
    console.log("✅ API: Added unavailable time slot:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API: Failed to add unavailable time slot:", error);
    throw error;
  }
};

// حذف فترة زمنية غير متاحة
export const removeUnavailableTimeSlotApi = async (date, timeSlotId) => {
  try {
    console.log("🗑️ API: Removing unavailable time slot:", { date, timeSlotId });
    const response = await axios.delete(`${BASE_URL}/api/unavailable-time-slots/remove`, {
      data: { date, timeSlotId }
    });
    console.log("✅ API: Removed unavailable time slot:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API: Failed to remove unavailable time slot:", error);
    throw error;
  }
};

// حذف جميع الفترات الز��نية غير المتاحة لتاريخ معين
export const removeAllUnavailableTimeSlotsForDateApi = async (date) => {
  try {
    console.log("🗑️ API: Removing all unavailable time slots for date:", date);
    const response = await axios.delete(`${BASE_URL}/api/unavailable-time-slots/remove-all`, {
      data: { date }
    });
    console.log("✅ API: Removed all unavailable time slots for date:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API: Failed to remove all unavailable time slots for date:", error);
    throw error;
  }
};